//export function Spinner({ size = 40 }) {
//const Spinner = (size) => {
//const Spinner = ({ size }) => {
const Spinner = (props) => {

  return (
    <div
      style = {{
        width: props.size + 'px',
        height: props.size + 'px',
        border: '4px solid #e5e7eb',
        borderTop: '4px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />
  );
}

export default Spinner;
